import { RootState } from '../store'

export const partsSelector = (state: RootState) => {
  const { parts } = state

  return parts
}
